export default __webpack_public_path__ + "static/media/gallery01.4cf1ab6a.jpg";